module.exports = __webpack_public_path__ + "img/imgYes.17620fe6.svg";